export default "__VITE_PUBLIC_ASSET__75b3c9f8__"